import { ComponentType, memo, ReactNode } from "react";
import classNames from "classnames";
import pluralize from "pluralize";
import { SelectedRowIds } from "react-table";

import styles from "./style.module.scss";

export type TableSelectionActionProps = {
  total: number,
  toggleAllRowsSelected: (value?: boolean | undefined) => void,
  selectedRowIds: SelectedRowIds,
}

export type SelectionActionsProps = {
  className?: string,
  total: number,
  children?: (props: TableSelectionActionProps) => ReactNode,
  showSelectedItemsCount?: boolean,
  showSelectedAll?: boolean,
  toggleAllRowsSelected: (value?: boolean | undefined) => void,
  selectedRowIds: SelectedRowIds,
  entityName?: string
}

export const SelectionActions = memo<SelectionActionsProps>((
  {
    className,
    total,
    showSelectedItemsCount,
    showSelectedAll,
    selectedRowIds,
    toggleAllRowsSelected,
    entityName,
    children,
  }) => {
  return (
    <div className={classNames(className, styles.root)}>
      {
        showSelectedItemsCount &&
        <p className={styles.selected}>
          {selectedRowIds.count} {pluralize(entityName as string, selectedRowIds.count)} selected
        </p>
      }
      {
        showSelectedAll &&
        <button
          type="button"
          onClick={() => toggleAllRowsSelected(!selectedRowIds.selectedAll)}
          className={styles.selectAll}>
          {
            selectedRowIds.selectedAll
              ? `Unselect all ${pluralize(entityName as string, 2)}`
              : `Select all ${total} filtered ${pluralize(entityName as string, total)}`
          }
        </button>
      }
      {
        children?.({
          total,
          selectedRowIds,
          toggleAllRowsSelected,
        })
      }
    </div>
  );
});

(SelectionActions as ComponentType<SelectionActionsProps>).defaultProps = {
  showSelectedItemsCount: true,
  showSelectedAll: true,
  entityName: "item",
};


export default SelectionActions;
